"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var locale = {
    alert: {
        close: 'Close',
    },
    calendar: {
        nextMonth: 'Next month',
        previousMonth: 'Previous month',
        nextYear: 'Next year',
        previousYear: 'Previous year',
    },
    dateInput: {
        placeholder: 'mm/dd/yyyy',
    },
    monthInput: {
        placeholder: 'mm/yyyy',
    },
    formControl: {
        required: 'Required field',
    },
    input: {
        clear: 'Clear',
    },
    modal: {
        close: 'Close',
    },
    monthPaginator: {
        close: 'Close',
        show: 'Show months',
    },
    paginator: {
        of: 'of',
        previousPage: 'Previous page',
        nextPage: 'Next page',
        currentPage: 'Current page',
    },
    dateRangeField: {
        separator: 'until',
    },
    select: {
        createItem: 'Select an item or type a new value',
        emptyItem: 'No results were found',
        loadingItem: 'Loading...',
        removeItem: 'Remove',
    },
    combobox: {
        showOptions: 'Show options',
        hideOptions: 'Hide options',
        createItem: 'Select an item or type a new value',
        emptyItem: 'No results were found',
        loadingItem: 'Loading...',
        removeItem: 'Remove',
    },
    tableFooter: {
        results: {
            zero: 'results',
            one: 'result',
            other: 'results',
        },
    },
    aggregators: {
        count: 'Count',
        average: 'Average',
        maximum: 'Maximum',
        minimum: 'Minimum',
        percentage: 'Percentage',
    },
    draggable: {
        search: 'Search',
        allItems: 'All items',
        all: 'all',
    },
    droppable: {
        isOver: 'Drop the item here to insert into the table',
        isNotOver: 'Drag items to insert into table',
    },
    pivotTableBoard: {
        availableFields: 'Available fields',
        rows: 'Rows',
        columns: 'Columns',
        kindOfPresentation: 'Kind of presentation',
        appliedFilters: 'Applied filters',
        clearFilters: 'Clear filters',
        clearTable: 'Clear table',
        clearTableTitle: 'Do you want to clear the table?',
        clearTableCancel: 'Cancel',
        clearTableConfirm: 'Clear',
        generateTable: 'Generate table',
    },
};
exports.default = locale;
//# sourceMappingURL=en-US.js.map